export enum TraxisEntitlementState {
  Entitled = 'Entitled',
  PurchaseStarted = 'PurchaseStarted'
}
